import React from 'react';
import { FiCheckCircle, FiShield, FiTrendingUp } from 'react-icons/fi';
import ContactForm from './ContactForm';

export default function Hero() {
  return (
    <section className="relative w-full bg-[linear-gradient(180deg,#fbfbfa,rgba(255,255,255,0.98))]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 items-center lg:grid-cols-12 pt-6 sm:pt-8 lg:pt-12 pb-12 sm:pb-16 lg:pb-20">
          <div className="lg:col-span-7">
            <div className="max-w-3xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-[var(--brand-accent)]/10 px-3 py-1 text-xs font-semibold text-[var(--brand-accent)]">Online cancellation service</span>

              <h1 className="mt-6 text-3xl font-extrabold leading-tight text-[var(--brand-ink)] sm:text-4xl lg:text-5xl">
                CANCEL YOUR SUBSCRIPTION FREE AND IMMEDIATELY THROUGH OUR ONLINE CANCELLATION SERVICE.
              </h1>

              <p className="mt-4 text-lg text-[var(--text-muted)]">Our operators are trained by our partners to answer all your questions quickly and efficiently.</p>


              <div className="mt-10 grid gap-6 sm:grid-cols-3">
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-3">
                    <div className="rounded-md bg-[var(--brand-accent)]/10 p-2 text-[var(--brand-accent)]"><FiCheckCircle className="h-5 w-5" /></div>
                    <div>
                      <div className="text-sm font-semibold text-[var(--brand-ink)]">Simplified support</div>
                      <div className="text-sm text-[var(--text-muted)]">Manage your subscription in one click.</div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-3">
                    <div className="rounded-md bg-[var(--brand-accent)]/10 p-2 text-[var(--brand-accent)]"><FiShield className="h-5 w-5" /></div>
                    <div>
                      <div className="text-sm font-semibold text-[var(--brand-ink)]">Recognized expertise</div>
                      <div className="text-sm text-[var(--text-muted)]">We support partner sites professionally.</div>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-3">
                    <div className="rounded-md bg-[var(--brand-accent)]/10 p-2 text-[var(--brand-accent)]"><FiTrendingUp className="h-5 w-5" /></div>
                    <div>
                      <div className="text-sm font-semibold text-[var(--brand-ink)]">Agents at your service</div>
                      <div className="text-sm text-[var(--text-muted)]">Fast and expert responses.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <div className="w-full max-w-md rounded-2xl border bg-white p-6 shadow-lg">
              <h2 className="text-lg font-bold text-[var(--brand-ink)]">Get help now</h2>
              <p className="mt-2 text-sm text-[var(--text-muted)]">Enter the email used when subscribing and our agents will help you.</p>
              <div className="mt-4">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
